<template>
    <div>
        <slot/>
    </div>
</template>

<script>
import svg4everybody from 'svg4everybody';

export default {
    name: 'app',
    mounted() {
        svg4everybody();
    },
};
</script>

<style lang="scss">
    @import "~wowjs/css/libs/animate";
    @import "base/lists";
    @import "base/media";
    @import "base/fonts";
    @import "base/layout";
    @import "base/transitions";
    @import "components/main";
    @import "base/typography";
    @import "mixins/button";
    @import "mixins/wysiwyg";
    @import "mixins/select";
    @import "mixins/pseudo-elements";
    @import "mixins/horizontal-rule";
    @import "components/404";
    @import "components/hero";
    @import "components/team";
    @import "components/header";
    @import "components/footer";
    @import "components/careers";
    @import "components/stories";
    @import "components/timeline";
    @import "components/locations";
    @import "components/cta-block";
    @import "components/brand-blog";
    @import "components/style-guide";
    @import "components/video-modal";
    @import "components/contact-form";
    @import "components/award-winners";
    @import "components/search-results";
    @import "components/brand-strategy";
    @import "components/brand-services";
    @import "components/brand-statement";
    @import "components/brand-blog-post";
    @import "components/brand-strengths";
    @import "components/brand-framework";
</style>



// WEBPACK FOOTER //
// App.vue?7f64f105